import request from 'superagent';
import { addModalExtra, addModalCategory, updateTrolleyMetaExtras, updateTrolleyMetaCategories } from '.';
var RECOMMENDATION_EXTRAS = 'attach';
var RECOMMENDATION_CATEGORIES = 'relevantcategories';
export var FETCH_RECOMMENDATIONS_FAILED = 'FETCH_RECOMMENDATIONS_FAILED';
export var FETCH_RECOMMENDATIONS_SUCCEEDED = 'FETCH_RECOMMENDATIONS_SUCCEEDED';
export var FETCH_RECOMMENDATIONS_COMPLETED = 'FETCH_RECOMMENDATIONS_COMPLETED';
export var FETCH_RECOMMENDATIONS_INITIATED = 'FETCH_RECOMMENDATIONS_INITIATED';
/**
 * Mark a recommendations request with given status
 * @method fetchRecommendationsStatus
 * @param  {String}  type  The type of the status
 * @return {Action}        Action of FETCH_RECOMMENDATIONS_SUCCEEDED type
 */

export var fetchRecommendationsStatus = function fetchRecommendationsStatus(type) {
  return function (partNumber) {
    return {
      type: type,
      partNumber: partNumber
    };
  };
};
/**
 * Mark a recommendations request as successful
 */

export var fetchRecommendationsSucceeded = fetchRecommendationsStatus(FETCH_RECOMMENDATIONS_SUCCEEDED);
/**
 * Mark a recommendations request as failed
 */

export var fetchRecommendationsFailed = fetchRecommendationsStatus(FETCH_RECOMMENDATIONS_FAILED);
/**
 * Mark a recommendations request as initiated
 */

export var fetchRecommendationsInitiated = fetchRecommendationsStatus(FETCH_RECOMMENDATIONS_INITIATED);
/**
 * Mark a recommendations request as completed
 */

export var fetchRecommendationsCompleted = fetchRecommendationsStatus(FETCH_RECOMMENDATIONS_COMPLETED);
/**
 * Fetch recommendations for product by type
 * @method fetchRecommendations
 * @param  {String}       type        The type of recommendation to fetch
 * @param  {String}       partNumber  The part number to use
 * @return {ThunkAction}              Action dispatcher
 */

export var fetchRecommendations = function fetchRecommendations(type, partNumber) {
  return function (action) {
    return function (update) {
      return function (dispatch) {
        dispatch(fetchRecommendationsInitiated());
        var options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/vnd.argos-product.v2+json'
          },
          credentials: 'include'
        };
        request.get("/product-api/recommendations-service/partNumber/".concat(partNumber, "/type/").concat(type, "?returnMeta=true"), options).retry(3).end(function (error, response) {
          if (error) {
            dispatch(fetchRecommendationsFailed(partNumber));
          } else {
            var _response$body$data = response.body.data,
                data = _response$body$data.data,
                included = _response$body$data.included; // Parse recommendations

            Object.keys(data.relationships).reduce(function (list, key) {
              return list.concat(data.relationships[key].data);
            }, []).forEach(function (entry) {
              var findId = function findId(resource) {
                return resource.id === entry.id && resource.type === entry.type;
              };

              var recommendation = included.find(findId);
              recommendation.placement = data.id;
              recommendation.model = recommendation.type;
              dispatch(action(recommendation));
            });
            dispatch(update(data.attributes));
            dispatch(fetchRecommendationsSucceeded(partNumber));
          }

          dispatch(fetchRecommendationsCompleted(partNumber));
        });
      };
    };
  };
};
/**
 * Fetch extra recommendations
 * @method fetchExtraRecommendations
 * @param  {String}       partNumber  The part number to use
 * @return {ThunkAction}              Dispatcher of ThunkAction
 */

export var fetchExtraRecommendations = function fetchExtraRecommendations(partNumber) {
  return function (dispatch) {
    dispatch(fetchRecommendations(RECOMMENDATION_EXTRAS, partNumber)(addModalExtra)(updateTrolleyMetaExtras));
  };
};
/**
 * Fetch category recommendations
 * @method fetchCategoryRecommendations
 * @param  {String}       partNumber  The part number to use
 * @return {ThunkAction}              Dispatcher of ThunkAction
 */

export var fetchCategoryRecommendations = function fetchCategoryRecommendations(partNumber) {
  return function (dispatch) {
    dispatch(fetchRecommendations(RECOMMENDATION_CATEGORIES, partNumber)(addModalCategory)(updateTrolleyMetaCategories));
  };
};
export var fetchRecommendationsIfNeeded = function fetchRecommendationsIfNeeded(partNumber) {
  return function (dispatch) {
    dispatch(fetchExtraRecommendations(partNumber));
    dispatch(fetchCategoryRecommendations(partNumber));
  };
};